
(function($) {

    /**
     * Add <a /> for skip to content and navigation to DOM. Can 
     * be accessed and viewed by pressing tab, they are only 
     * visually hidden when not in focus.
     */
    var skipToHtml = {
        skipToContent: '<a id="skip-to-content" class="hide-visually" href="#page-wrapper" accesskey="I" tab-index="0" title="Hoppa till sidans innehåll">Hoppa till sidans innehåll</a>',
        skipToNavigation: '<a id="skip-to-navigation" class="hide-visually" href="#primary-menu" accesskey="N" tab-index="0" title="Hoppa till sidans navigering">Hoppa till sidans navigering</a>'
    }
    
    var $body = $('body');
    var $skipToContent = $(skipToHtml.skipToContent);
    var $skipToNavigation = $(skipToHtml.skipToNavigation);

    $body.prepend($skipToContent);
    $body.prepend($skipToNavigation);

    $skipToNavigation.focusin(function() {
        $this = $(this);
        $this.attr('style', 'position:relative; clip:rect(auto)');
    });

    $skipToNavigation.focusout(function() {
        $this = $(this);
        $this.attr('style', '');
    });

    $skipToContent.focusin(function() {
        $this = $(this);
        $this.attr('style', 'position:relative; clip:rect(auto)');
    });

    $skipToContent.focusout(function() {
        $this = $(this);
        $this.attr('style', '');
    });

})(jQuery);